// extracted by mini-css-extract-plugin
module.exports = {"pay-support-wrapper":"rj5bg","terms-conditions":"FeXjk","faq-wrapper":"_25q3I","faq-title":"_28FRx"};